module.exports = __webpack_public_path__ + "img/contact10.b6012380.png";